export const CREATE_DICTIONARY_WORDS_FOR_TYPE = {
  START: 'START_CREATE_DICTIONARY_WORDS_FOR_TYPE',
  COMPLETE: 'COMPLETE_CREATE_DICTIONARY_WORDS_FOR_TYPE',
  FAIL: 'FAIL_CREATE_DICTIONARY_WORDS_FOR_TYPE',
}

export const TRANSFER_DICTIONARY_WORD_TO_INGREDIENT = {
  START: 'START_TRANSFER_DICTIONARY_WORD_TO_INGREDIENT',
  COMPLETE: 'COMPLETE_TRANSFER_DICTIONARY_WORD_TO_INGREDIENT',
  FAIL: 'FAIL_TRANSFER_DICTIONARY_WORD_TO_INGREDIENT',
}
